var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"1","height":"20","transform":"translate(0 11) rotate(-90)"}}),_c('rect',{attrs:{"width":"1","height":"20","transform":"translate(10)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }